import styled, { css } from 'styled-components';
import { Image } from '@sainsburys-tech/bolt';
import { PlusIcon } from '@sainsburys-tech/bolt-icons';
var colorClasses = {
  white: '#fff',
  'winter-white': '#fff',
  grey: '#ccc',
  'smoke-grey': '#788387',
  'flint-grey': '#646661',
  'dove-grey': '#9d9da5',
  'space-grey': '#757478',
  'light-grey': '#b6b6b6',
  'mid-grey': '#8c8c8c',
  'granite-grey': '#404145',
  'silver-grey': '#858386',
  'stone-grey': '#928e85',
  graphite: '#454343',
  black: '#000',
  'black-gloss': '#000',
  'black-oak': '#000',
  blue: '#69c',
  'midnight-blue': '#020731',
  'navy-blue': '#000080',
  'soft-blue': '#d1e2f6',
  'sky-blue': '#77b5fe',
  'pale-blue': '#d1e1f6',
  'ocean-blue': '#03719c',
  'underwater-blue': '#03719c',
  'kingfisher-blue': '#1d6b72',
  'indigo-blue': '#373f54',
  'dark-blue': '#0b1124',
  darkblue: '#0b1124',
  'space-black': '#2E2C2F',
  lightblue: '#9babc5',
  'light-blue': '#9babc5',
  'pastel-blue': '#bcd2ee',
  'fiesta-blue': '#007ace',
  'bright-blue': '#19f5f6',
  'mid-blue': '#3b7ddb',
  olive: '#566b30',
  yellow: '#f8e81c',
  'bright-yellow': '#ffe830',
  'light-yellow': '#ffff9e',
  'dark-yellow': '#fec908',
  biscuit: '#957c40',
  mustard: '#a17834',
  turquoise: '#34dddd',
  teal: '#0b5f6a',
  taupe: '#bfb0a9',
  tan: '#b47118',
  pink: '#f6c5b2',
  'soft-pink': '#fadadd',
  'pale-pink': '#ffeeeb',
  darkpink: '#f4bcaf',
  'dark-pink': '#f4bcaf',
  'light-pink': '#ffeef5',
  'mid-pink': '#ff685e',
  'bright-pink': '#ff5f97',
  'sorbet-pink': '#f78fa7',
  'blush-pink': '#fe828c',
  slate: '#374753',
  gunmetal: '#4f5a65',
  red: '#d02647',
  'poppy-red': '#df3327',
  'dark-red': '#8d0000',
  'bright-red': '#ff3030',
  purple: '#9013fe',
  'purple-fizz': '#7c3061',
  'bright-purple': '#bf00ff',
  'light-purple': '#cbabea',
  'mid-purple': '#81007f',
  'dark-purple': '#450d52',
  'true-purple': '#5f2a94',
  plum: '#4e0032',
  pewter: '#596065',
  peach: '#fae0ad',
  orange: '#f6a623',
  'burnt-orange': '#cf5300',
  'dark-orange': '#cc5501',
  'mid-orange': '#ff8101',
  'light-orange': '#fdb957',
  navy: '#002a5e',
  mocha: '#987e6d',
  mono: '#8c8b86',
  mint: '#85d9bf',
  mink: '#816e70',
  lime: '#81cf09',
  lilac: '#ada1e6',
  'light-lilac': '#e5d6f3',
  lavender: '#b378d3',
  lagoon: '#38adbb',
  heather: '#8d7382',
  'funky-fuchsia': '#ff0080',
  'duck-egg': '#b9d0c8',
  cream: '#fef9e7',
  cranberry: '#820024',
  coral: '#ff5f67',
  chocolate: '#432000',
  champagne: '#e3dec0',
  camel: '#b99772',
  'cafe-mocha': '#897167',
  birch: '#f8dfa1',
  'black-brown': '#654321',
  burgundy: '#590423',
  brown: '#6f3803',
  'autumn-brown': '#541108',
  'light-brown': '#b97e56',
  'dark-brown': '#4a1f00',
  beige: '#f2e39c',
  aubergine: '#4b2145',
  aqua: '#01ffff',
  aluminium: '#e9e9e9',
  anthracite: '#2d2b28',
  ash: '#252426',
  beech: '#e5ccac',
  'beech-effect': '#cd9337',
  berry: '#7e204d',
  'black-ash': '#5f5f5f',
  bronze: '#a24b20',
  brass: '#a24b20',
  cappuccino: '#cbb79c',
  charcoal: '#3d3e43',
  chrome: '#fff',
  'chrome-coloured': '#e9e9e9',
  clear: '#ddfaf1',
  'clear-glass': '#ddfaf1',
  glass: '#ddfaf1',
  coffee: '#3e1e10',
  crystal: '#c6ffdd',
  'dark-oak': '#51382b',
  'dark-wood': '#853a15',
  denim: '#1c273b',
  middenim: '#aac5d4',
  darkdenim: '#1c273b',
  'light-denim': '#cbe1fb',
  'mid-denim': '#86b3e6',
  'dark-denim': '#00052d',
  fawn: '#ebdcb3',
  fuchsia: '#c2008b',
  gold: '#f5c629',
  starlight: '#f4edc6',
  'gold-coloured': '#590423',
  granite: '#434343',
  'lime-green': '#81cf09',
  green: '#008601',
  'apple-green': '#b6c538',
  'pale-green': '#98fb98',
  'bottle-green': '#006a4e',
  'bright-green': '#78f67b',
  'light-green': '#9bff93',
  'mid-green': '#68b54b',
  'dark-green': '#404c3d',
  'fern-green': '#7e843e',
  'leaf-green': '#3a5f0b',
  indigo: '#4b0082',
  ivory: '#feffec',
  'jet-black': '#000',
  khaki: '#c3b48b',
  'light-khaki': '#beb98f',
  latte: '#dac2a3',
  'light-oak': '#face96',
  'light-wax': '#face96',
  'light-wood': '#face96',
  'oak-effect': '#face96',
  mirrored: '#fff',
  mulberry: '#542538',
  natural: '#e9e9e9',
  'natural-wood': '#715735',
  'natural-chalk': '#d2c8bf',
  nude: '#fbe9dc',
  oak: '#b88b62',
  oatmeal: '#e1d9c8',
  peacock: '#2a4d4a',
  pine: '#f9be73',
  'pine-effect': '#f9be73',
  'rose-gold-coloured': '#fbd8cb',
  'rose-gold': '#fbd8cb',
  sand: '#cdae66',
  silver: '#fff',
  'silver-effect': '#fff',
  'silver-coloured': '#e9e9e9',
  'stainless-steel': '#fff',
  stone: '#a89f91',
  sunburst: '#ffa300',
  terracotta: '#833a19',
  titanium: '#e8e8e8',
  'wenge-effect': '#3d312d',
  wheat: '#b89547',
  'white-gloss': '#f7f7f7',
  wine: '#5a0101',
  neutral: '#edf3f9',
  bamboo: '#d9d0ae',
  chestnut: '#986960',
  jade: '#00a86b',
  lemon: '#00a86b',
  platinum: '#ada7a7',
  torte: '#816f5b',
  'white-gold': '#efefef',
  walnut: '#5b2f21',
  rust: '#b7410e',
  cinnamon: '#d2691e',
  pistachio: '#93c572',

  /* colour groups */
  pinks: '#f6c5b2',
  blues: '#69c',
  beiges: '#f2e39c',
  yellows: '#ffec00',
  reds: '#d02647',
  whites: '#fff',
  purples: '#9013fe',
  pastels: '#dcf9fd',
  oranges: '#f5a623',
  neutrals: '#edf3f9',
  greys: '#ccc',
  greens: '#008601',
  creams: '#fef9e7',
  chocolates: '#432000',
  browns: '#6f3803',
  blacks: '#000',
  woods: '#face96',
  metallic: '#cecece',
  metallics: '#cecece',
  'emerald-green': '#294F40',
  'ink-blue': '#26314E',
  'dark-grey': '#38393B',
  'moss-green': '#384b2f',
  'sage-green': '#585c4b',
  'dusty-rose': '#a24747',
  'dusty-pink': '#ab4d4d',
  'mid-tan': '#97572b'
};
var camouflageColors = {
  default: '#c3654b',
  light: '#eee3cf',
  'dark:': '#636c3f'
};
var multicolors = ['#9ed110', '#50b517', '#179067', '#476eaf', '#9f49ac', '#cc42a2', '#ff3ba7', '#ff5800', '#ff8100', '#feac00', '#fc0', '#ede604'];
var metalcolors = ['rgba(50, 55, 60, 0.25)', 'rgba(100, 100, 100, 0.2)', 'rgba(106, 110, 115, 0.51)', 'rgba(206, 210, 215, 0.1)', 'rgba(206, 210, 215, 0.2)', 'rgba(106, 110, 115, 0.1)', 'rgba(100, 100, 100, 0.75)', 'rgba(206, 210, 215, 0.9)', 'rgba(255, 255, 255, 0.5)', 'rgba(255, 255, 255, 0.5)', 'rgba(0, 0, 0, 0.2)', 'rgba(50, 50, 50, 0.25)'];
var ColorSwatchOptions = styled.span.withConfig({
  displayName: "ColorSwatchstyles__ColorSwatchOptions",
  componentId: "jvpifx-0"
})(["display:flex;position:relative;font-size:", ";.color-label{align-self:center;line-height:1;margin-left:11px;}"], function (props) {
  return props.theme.font.size.base;
});
var FabricSwatch = styled.div.withConfig({
  displayName: "ColorSwatchstyles__FabricSwatch",
  componentId: "jvpifx-1"
})(["position:relative;display:inline-block;height:", "px;width:", "px;cursor:pointer;"], function (props) {
  return props.$imageLength;
}, function (props) {
  return props.$imageLength;
});
var FabricTile = styled(Image).withConfig({
  displayName: "ColorSwatchstyles__FabricTile",
  componentId: "jvpifx-2"
})(["padding:1px;border:1px solid transparent;border-radius:3px;&:hover{border-color:", ";}"], function (props) {
  return props.theme.color.palette['blue-60'];
});
var Swatch = styled.div.withConfig({
  displayName: "ColorSwatchstyles__Swatch",
  componentId: "jvpifx-3"
})(["position:relative;display:inline-block;height:24px;width:24px;border-radius:50%;border:1px solid transparent;cursor:pointer;&:hover{border-color:", ";}", " .effect,&::before,&::after{content:'';display:block;position:absolute;left:2px;right:2px;top:2px;bottom:2px;border-radius:50%;}", " .effect{z-index:2;opacity:0.75;height:18px;width:18px;overflow:hidden;&.medium{height:26px;width:26px;}&.camouflage{background-color:", ";&-light{background-color:", ";}&-dark{background-color:", ";}}}", " & + &{position:absolute;left:0;top:0;clip:rect(0,20px,20px,12px);transform:rotate(45deg);z-index:2;", "}"], function (props) {
  return props.theme.color.palette['blue-100'];
}, function (props) {
  return props.selected && css(["border-color:", ";"], props.theme.color.palette['blue-100']);
}, function (props) {
  return css(["&::before{background-color:", ";}&::after{border:solid 1px ", ";z-index:3;}"], colorClasses[props.color], props.theme.color.monochrome.dark);
}, camouflageColors.default, camouflageColors.light, camouflageColors.dark, function (props) {
  return props.size === 'medium' && css(["height:32px;width:32px;"]);
}, function (props) {
  return props.size === 'medium' && css(["clip:rect(0,32px,32px,16px);"]);
});

var circle = function circle(size, isTypeOne) {
  return "\n  content: '';\n  position: absolute;\n  border-radius: 50%;\n  left: calc(50% - ".concat(size / 2, "px);\n  top: calc(50% - ").concat(size / 2, "px);\n  width: ").concat(size, "px;\n  height: ").concat(size, "px;\n  ").concat(isTypeOne ? "clip: rect(0, ".concat(size, "px, ").concat(size, "px, ").concat(size / 2, "px);") : "clip: rect(0, ".concat(size / 2, "px, ").concat(size, "px, 0);"), "\n");
};

var smallWheel = 18;
var mediumWheel = 26;
/* eslint-disable */

var multicolorFunc = function multicolorFunc() {
  var str = '';

  for (var i = 0; i < multicolors.length; i++) {
    str += "&:nth-child(".concat(i + 1, ")::after {\n      ").concat(i < 6 ? "transform: rotate(".concat(30 * (1 + i), "deg);\n        z-index: ").concat(multicolors.length - i, ";\n        background-color: ").concat(multicolors[i], ";") : "transform: rotate(".concat(-30 + 30 * (1 + i), "deg);\n        background-color: ").concat(multicolors[i], ";"), "\n    }");
  }

  return str;
};

var metalcolorFunc = function metalcolorFunc() {
  var str = '';

  for (var i = 0; i < metalcolors.length; i++) {
    str += "&:nth-child(".concat(i + 1, ")::after {\n      background-color: ").concat(metalcolors[i], ";\n    }");
  }

  return str;
};
/* eslint-enable */


var Wheel = styled.div.withConfig({
  displayName: "ColorSwatchstyles__Wheel",
  componentId: "jvpifx-4"
})(["overflow:hidden;position:relative;border-radius:50%;left:2px;top:2px;width:18px;height:18px;", " ", " .blur{position:relative;transform:scale(1.35);border-radius:50%;width:18px;height:18px;", "}.slice{", " &:nth-child(n + 7){", "}&:nth-child(n + 7)::after{", "}&::after{", "}", " &.metal{", "}}"], function (props) {
  return props.classId === 'metal' && css(["opacity:0.35;"]);
}, function (props) {
  return props.size === 'medium' && css(["height:26px;width:26px;"]);
}, function (props) {
  return props.size === 'medium' && css(["height:26px;width:26px;"]);
}, function (props) {
  return circle(props.size === 'medium' ? mediumWheel : smallWheel, true);
}, function (props) {
  return circle(props.size === 'medium' ? mediumWheel : smallWheel, false);
}, function (props) {
  return circle(props.size === 'medium' ? mediumWheel : smallWheel, true);
}, function (props) {
  return circle(props.size === 'medium' ? mediumWheel : smallWheel, false);
}, multicolorFunc(), metalcolorFunc());
var ColorSwatchList = styled.div.withConfig({
  displayName: "ColorSwatchstyles__ColorSwatchList",
  componentId: "jvpifx-5"
})(["& > ul{display:none;@media screen and (min-width:", "){display:flex;flex-wrap:wrap;}", " ", " ", "}"], function (props) {
  return props.theme.size.breakpoint['min-width'].md;
}, function (props) {
  return (props.isFixed || props.$isFabricSwatches) && css(["display:flex;flex-wrap:wrap;"]);
}, function (props) {
  return props.showPrompt && css(["justify-content:center;"]);
}, function (props) {
  return props.$isFabricSwatches && css(["align-items:center;"]);
});
var ColorSwatchListLi = styled.li.withConfig({
  displayName: "ColorSwatchstyles__ColorSwatchListLi",
  componentId: "jvpifx-6"
})(["display:inline-block;height:24px;width:24px;margin:0 1%;", " ", " ", ""], function (props) {
  return props.size === 'medium' && css(["height:32px;width:32px;margin:1.1%;"]);
}, function (props) {
  return props.disabled && css(["opacity:0.5;cursor:not-allowed;pointer-events:none;position:relative;&::before{content:'';top:0;left:calc(48%);position:absolute;background:", ";width:2px;height:100%;z-index:10;transform:rotate(45deg);}&::after{content:'';top:0;left:0;border-radius:50%;position:absolute;width:calc(100% - 4px);height:calc(100% - 4px);border:solid ", " 2px;z-index:-1;}"], props.theme.color.monochrome.dark, props.theme.color.monochrome.base);
}, function (props) {
  return props.$isFabricSwatches && css(["margin:0 4px 0 0;", ""], props.disabled && css(["&::before{content:none;}&::after{content:none;}"]));
});
var ColorSwatchListSummary = styled.p.withConfig({
  displayName: "ColorSwatchstyles__ColorSwatchListSummary",
  componentId: "jvpifx-7"
})(["color:", ";&&{margin-bottom:0;}.color-label{margin-left:0;}", ""], function (props) {
  return props.theme.color.monochrome.dark;
}, function (props) {
  return props.isFixed && css(["display:none;"]);
});
var ShowMorePlusIcon = styled(PlusIcon).withConfig({
  displayName: "ColorSwatchstyles__ShowMorePlusIcon",
  componentId: "jvpifx-8"
})(["cursor:pointer;margin:0 auto;position:relative;top:50%;transform:translateY(-50%);height:20px;width:20px;border:1px solid ", ";border-radius:15px;"], function (props) {
  return props.theme.color.monochrome.light;
});
export { ColorSwatchOptions, Swatch, FabricSwatch, FabricTile, Wheel, ColorSwatchList, ColorSwatchListLi, ColorSwatchListSummary, ShowMorePlusIcon };